import React from "react";
import Header from "./Header";
import Footer from "./Footer";

function Contactus() {
    return (
        <>
            <Header></Header>
            <div className="contact">

                <h1 className="img-info cnts">contact us</h1>
                <img src="./images/contact.jpg" className="contact-img"></img>

                <div className="contact-logo">
                    <div className="contact-info">
                        <i class="fa-solid fa-house contact-home"></i>
                        <h3 className="contact-title">address</h3>
                        <p className="contact-para">gala no.6/7/8, shanta ind. estate,</p>
                        <p>Mira Road (E), Thane-401107.</p>
                    </div>
                    
                    <div className="contact-info">
                        <i class="fa-solid fa-envelope contact-home"></i>
                        <h3 className="contact-title">e-mail</h3>
                        <p className="contact-para"><a href="#">sales@hexatechseal.com</a></p>
                        <p> <a href="#" className="a">Info@hexatechseal.com</a> </p>
                    </div>
                    <div className="contact-info">
                        <i class="fa-solid fa-phone contact-home"></i>
                        <h3 className="contact-title">phone</h3>
                        <p className="contact-para">9167862525</p>
                        <p>9967255986</p>
                    </div>
                    <div className="contact-info">
                        <i class="fa-solid fa-clock contact-home"></i>
                        <h3 className="contact-title">hours</h3>
                        <p className="contact-para">Monday-saturday: 9am to 8pm</p>
                        <p>Sunday: Closed</p>
                    </div>
                </div>

                <div className="sec-contact">
                    <h3 className="sec-conact-head">hexatech seal solution, llp.</h3>
                    <p className="sec-conact-para">Address: gala no.6/7/8, shanta ind. estate, opp. dara's dhaba,kashimira Mira Road (E),</p>
                    <p className="sec-conact-para">Post Code: Thane-401107.</p>
                    <p className="sec-conact-para">Mobile / whatsApp: +91 9167862525</p>
                    <p className="sec-conact-para">E-mail: <a href="#" className="emal">hexatechseal@gmail.com</a></p>
                </div>
            </div>

            <Footer></Footer>
        </>
    )
};

export default Contactus